import { TopLevelMenuCategory } from './types/productTypes'

export const DefaultSwitchSelectionProducts: readonly string[] = [
  '3042C-VW', // clipsal
  'PDL382C-VW', // PDL
  'P3042C-XW', // Clipsal Pro
  'PDLP382C-XW', // PDL Pro
]

export const TopLevelSelectionProducts: readonly {
  type: TopLevelMenuCategory
  defaultItems: readonly string[]
}[] = [
  { type: 'Switch', defaultItems: DefaultSwitchSelectionProducts },
  { type: 'Socket', defaultItems: ['3025C-VW', 'PDL395C-VW', 'P3025C-XW', 'PDLP395C-XW'] },
  { type: 'Wiser', defaultItems: ['CLP501902', 'PDL501902'] },
  { type: 'Other', defaultItems: ['S3043USBC-SV', 'PDL395USBAC-VW', 'P223H-3A', 'PDLP223H-3A'] },
  { type: 'Outdoor', defaultItems: ['O3015T-BK', 'PDLO394CS-BK'] },
]